import { httpClient } from "../api/httpClient";
import { API_ROUTES } from "../constants/apiRoutes";

export const toggleNewsFollowApi = async (id: number) => {
  return httpClient(`${API_ROUTES.FOLLOW_NEWS}?id=${id}`, {
    method: "POST",
  });
};
